var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBluePentagon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 230,
    height: 110,
    viewBox: "0 0 230 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.253906 0.626953H229.746V96.5963L115 109.907L0.253906 96.5963V0.626953Z",
    fill: "#0E59EB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBluePentagon);
export default __webpack_public_path__ + "static/media/BluePentagon.19e70f66f912fb288d78ca5074c70259.svg";
export { ForwardRef as ReactComponent };